import React from 'react';
import PropTypes from 'prop-types';
import LineSeries from 'components/line-series';
import {getTranslate} from 'utils/attribute-util';
import styles from './index.css';

export default class Dot extends React.Component {
  static propTypes = {
    active: PropTypes.bool,
    style: PropTypes.object,
    x: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    active: false,
    style: {},
    x: 0,
    y: 0,
  };

  getDotStyle(active, style) {
    const {fill} = style;
    return active
      ? {
          stroke: fill,
          strokeWidth: 1,
        }
      : {
          fill,
        };
  }

  render() {
    const {active, style, x, y} = this.props;
    const dotStyle = this.getDotStyle(active, style);
    return (
      <g className={styles.Dot} transform={getTranslate(x, y)}>
        <circle r={LineSeries.getRadius()} style={dotStyle} />
      </g>
    );
  }
}
